import { useQuery } from "@tanstack/react-query";
import { agentContractsApi } from "../services/api/agent-payouts.api";

const STALE_TIME_MS = 5 * 60_000;

/**
 * AD-790. Есть ли у пользователя агентский договор: от него, а не от роли в
 * событии, зависит, нужен ли пункт выплат в меню. Сервер отдаёт только свои
 * договоры, уже отправленные на подпись.
 *
 * Ответ нужен лишь меню, поэтому отказ запроса означает «пункта нет», а не ошибку
 * на экране. Сам экран выплат читает договоры сам и ошибку показывает.
 *
 * @param enabled `false`, когда пункт и так есть в подменю программы: лишний запрос
 *   на каждую загрузку меню организатору не нужен.
 */
export const useHasAgentContract = (enabled: boolean): boolean => {
  const { data } = useQuery({
    queryKey: ["agent-contracts", "my", "exists"],
    queryFn: () => agentContractsApi.listMyContracts({ page: 1, limit: 1 }),
    enabled,
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });

  return (data?.total ?? 0) > 0;
};
